import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const FileSignIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                strokeLinecap="square"
                d="M11.5 21.5c.833 0 3.2-1.4 4-3 1-2-1.5-2.5-3-1.5s1.5 5.5 3 4.5 1.5-1.5 2-.5c.78 1.561 1.5 0 2.5-2"
            />
            <path
                fill="currentColor"
                d="M18 15.5v.5h1v-.5h-1ZM7.5 21H8v-1h-.5v1Zm8.738-16.222-.346.361.346-.36Zm1.954 1.874.346-.361-.346.36ZM19 15.5V7.373h-1V15.5h1Zm-.462-9.21-1.954-1.873-.692.722 1.954 1.874.692-.722ZM15.546 4H5.5v1h10.046V4ZM4 5.5v14h1v-14H4ZM5.5 21h2v-1h-2v1ZM4 19.5A1.5 1.5 0 0 0 5.5 21v-1a.5.5 0 0 1-.5-.5H4ZM5.5 4A1.5 1.5 0 0 0 4 5.5h1a.5.5 0 0 1 .5-.5V4Zm11.084.417A1.5 1.5 0 0 0 15.546 4v1a.5.5 0 0 1 .346.139l.692-.722ZM19 7.373a1.5 1.5 0 0 0-.462-1.082l-.692.722a.5.5 0 0 1 .154.36h1Z"
            />
        </svg>
    </IconWrapper>
)
